/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { ColorPaletteService } from './color-palette-service';

@Component({
  selector: 'app-colors',
  templateUrl: './colors.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './colors.scss',
})
export class Colors implements OnInit {
  private colorPaletteService = inject(ColorPaletteService);

  public neutrals: any[] = [];
  public blues: any[] = [];
  public greens: any[] = [];
  public teals: any[] = [];
  public yellows: any[] = [];
  public oranges: any[] = [];
  public reds: any[] = [];
  public pinks: any[] = [];
  public purples: any[] = [];

  async ngOnInit() {
    const colors = await this.colorPaletteService.getColorVariables();

    // Every family is now a uniform 000-900 ramp (matching Neutral). See
    // libs/meadow/core/styles/PALETTE_MIGRATION.md.
    this.neutrals = this.filterColors(colors, this.rampNames('N'));
    this.blues = this.filterColors(colors, this.rampNames('B'));
    this.greens = this.filterColors(colors, this.rampNames('G'));
    this.teals = this.filterColors(colors, this.rampNames('T'));
    this.yellows = this.filterColors(colors, this.rampNames('Y'));
    this.oranges = this.filterColors(colors, this.rampNames('O'));
    this.reds = this.filterColors(colors, this.rampNames('R'));
    this.pinks = this.filterColors(colors, this.rampNames('Pi'));
    this.purples = this.filterColors(colors, this.rampNames('P'));
  }

  rampNames(prefix: string): string[] {
    return ['000', '100', '200', '300', '400', '500', '600', '700', '800', '900'].map(
      slot => `${prefix}${slot}`,
    );
  }

  filterColors(colors: any, keys: string[]): any[] {
    return keys.map(key => ({
      name: key,
      hex: colors[key],
    }));
  }
}
